<template>
	<div class="home-page" :class="{ 'mobile-fullscreen-mode': isMobileFullscreen }" @click="$store.commit('closeUserInfoBox')">
		<div class="app-container" :class="{ fullscreen: isFullscreen, 'mobile-fullscreen-mode': isMobileFullscreen }">
			<div class="navi-bar" v-show="!isMobileFullscreen">
				<div class="navi-bar-box">
					<div class="top">
						<div class="user-head-image" @click="handleAvatarClick">
							<!-- 未登录显示产品logo -->
							<img v-if="!isLoggedIn" src="/logo-128.png" alt="Logo" style="width: 38px; height: 38px; border-radius: 50%;" />
							<!-- 已登录显示用户头像 -->
							<head-image v-else :name="$store.state.userStore.userInfo?.nickName || ''" :size="38"
								:url="$store.state.userStore.userInfo?.headImageThumb || ''">
							</head-image>
						</div>

						<div class="menu">
							<router-link class="link" v-bind:to="'/home/index'">
								<div class="menu-item">
									<svg class="icon icon-home-svg" viewBox="0 0 1024 1024" width="20" height="20">
										<path d="M950.857143 508.562286L534.820571 96.109714a53.686857 53.686857 0 0 0-73.142857 0L45.714286 508.562286a18.285714 18.285714 0 0 0 24.576 27.062857l41.618285-37.741714V859.428571c0 50.285714 40.96 91.428571 91.428572 91.428572h182.857143c20.114286 0 36.571429-16.457143 36.571428-36.571429v-219.428571c0-30.171429 24.576-54.857143 54.857143-54.857143h109.714286c30.171429 0 54.857143 24.685714 54.857143 54.857143v219.428571c0 20.114286 16.457143 36.571429 36.571428 36.571429h182.857143c50.468571 0 91.428571-41.142857 91.428572-91.428572V497.883429l41.618285 37.741714a18.285714 18.285714 0 1 0 24.576-27.062857z" fill="currentColor"/>
									</svg>
								</div>
							</router-link>
							<div class="link" :class="{ 'router-link-active': $route.path === '/home/chat' }" @click="handleMenuClick('/home/chat')">
								<div class="menu-item">
									<span class="icon iconfont icon-chat"></span>
									<div v-show="unreadCount > 0" class="unread-text">{{ unreadCount }}</div>
								</div>
							</div>
							<div class="link" :class="{ 'router-link-active': $route.path === '/home/friend' }" @click="handleMenuClick('/home/friend')">
								<div class="menu-item">
									<span class="icon iconfont icon-friend"></span>
								</div>
							</div>
							<div class="link" :class="{ 'router-link-active': $route.path === '/home/group' }" @click="handleMenuClick('/home/group')">
								<div class="menu-item">
									<span class="icon iconfont icon-group" style="font-size: 28px"></span>
								</div>
							</div>
						</div>
					</div>

					<div class="botoom">
						<!-- 未登录状态：只显示登录按钮 -->
						<template v-if="!isLoggedIn">
							<div class="botoom-item" @click="goToLogin" title="登录">
								<span class="icon iconfont icon-exit" style="transform: scaleX(-1);"></span>
							</div>
						</template>
						<!-- 已登录状态：显示完整工具条 -->
						<template v-else>
							<div class="botoom-item" @click="isFullscreen = !isFullscreen" title="全屏">
								<i class="el-icon-full-screen"></i>
							</div>
							<div class="botoom-item" @click="showSetting" title="设置">
								<span class="icon iconfont icon-setting" style="font-size: 20px"></span>
							</div>
							<div class="botoom-item" @click="onExit()" title="退出">
								<Spinner v-if="isLoggingOut" size="small" />
								<span v-else class="icon iconfont icon-exit"></span>
							</div>
						</template>
					</div>
				</div>
			</div>
			<div class="content-box">
				<transition name="page-fade" mode="out-in">
					<router-view></router-view>
				</transition>
			</div>
			<setting :visible="showSettingDialog" @close="closeSetting()"></setting>
			<user-info v-show="uiStore.userInfo.show" :pos="uiStore.userInfo.pos" :user="uiStore.userInfo.user"
				@close="$store.commit('closeUserInfoBox')"></user-info>
			<full-image 
				:visible="uiStore.fullImage.show" 
				:url="uiStore.fullImage.url"
				:imageList="uiStore.fullImage.imageList"
				:currentIndex="uiStore.fullImage.currentIndex"
				:allowSwitch="uiStore.fullImage.allowSwitch"
				@close="$store.commit('closeFullImageBox')"
				@change="$store.commit('changeFullImageIndex', $event)"></full-image>
			<rtc-private-video ref="rtcPrivateVideo"></rtc-private-video>
			<rtc-group-video ref="rtcGroupVideo"></rtc-group-video>
		</div>
	</div>
</template>

<script>
import HeadImage from '../components/common/HeadImage.vue';
import Setting from '../components/setting/Setting.vue';
import UserInfo from '../components/common/UserInfo.vue';
import FullImage from '../components/common/FullImage.vue';
import RtcPrivateVideo from '../components/rtc/RtcPrivateVideo.vue';
import RtcPrivateAcceptor from '../components/rtc/RtcPrivateAcceptor.vue';
import RtcGroupVideo from '../components/rtc/RtcGroupVideo.vue';
import Spinner from '../components/common/Spinner.vue';
import { ensurePodReady, checkPodStatus } from '@/api/vncApi.js';
import http from '@/api/httpRequest.js';
import titleNotifier from '@/utils/titleNotifier.js';

export default {
	components: {
		HeadImage,
		Setting,
		UserInfo,
		FullImage,
		RtcPrivateVideo,
		RtcPrivateAcceptor,
		RtcGroupVideo,
		Spinner,
	},
	data() {
		return {
			showSettingDialog: false,
			showAccessRequest: false,
			pendingRequestCount: 0,
			lastPlayAudioTime: new Date().getTime() - 1000,
			isFullscreen: true,
			reconnecting: false,
			isLoggingOut: false
		}
	},
	methods: {
		onChatMenuClick() {
			// 跳转到聊天页面
			if (this.$route.path !== '/home/chat') {
				this.$router.push('/home/chat');
			}
			// 触发定位到第一个未读会话
			this.$nextTick(() => {
				this.$eventBus.$emit('locate-first-unread-chat');
			});
		},
		/**
		 * VNC Pod 预启动(简化版)
		 * 后台静默调用 happy-server 初始化接口
		 */
		async preloadVncPod() {
			try {
				const tokenKey = sessionStorage.getItem('tokenKey');
				if (!tokenKey) {
					return;
				}

				const response = await fetch(`${process.env.VUE_APP_HAPPY_SERVER_URL || 'https://happy.shadanai.com'}/v1/tasks/prelaunch`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						tokenKey: tokenKey
					})
				});

				const data = await response.json();
				if (data.credentials) {
					// 保存凭证到本地 credentials 服务器
					try {
						await fetch('http://localhost:9998/save-credentials', {
							method: 'POST',
							headers: { 'Content-Type': 'application/json' },
							body: JSON.stringify({
								HAPPY_AUTH_TOKEN: data.credentials.token,
								HAPPY_AUTH_PUBLIC_KEY: data.credentials.publicKey,
								HAPPY_AUTH_MACHINE_KEY: data.credentials.secret,
								HAPPY_MACHINE_ID: data.credentials.machineId
							})
						});
						console.log('[Home] 凭证已保存到本地');
					} catch (e) {
						console.log('[Home] 本地凭证服务器未运行');
					}
					
					// 保存到 localStorage 作为备份
					localStorage.setItem('HAPPY_CREDENTIALS', JSON.stringify(data.credentials));
				}
			} catch (error) {
				// Silent
			}
		},
		init() {
		// 监听来自 CLI 的凭证请求
		window.addEventListener('message', (event) => {
			if (event.data && event.data.type === 'CLI_REQUEST_CREDENTIALS') {
				console.log('[Home] 收到 CLI 凭证请求');
				this.sendCredentialsToCLI();
			}
		});
			this.$eventBus.$on('openPrivateVideo', (rctInfo) => {
				// 进入单人视频通话
				this.$refs.rtcPrivateVideo.open(rctInfo);
			});
			this.$eventBus.$on('openGroupVideo', (rctInfo) => {
				// 进入多人视频通话
				this.$refs.rtcGroupVideo.open(rctInfo);
			});

			// 监听来自 happy iframe 的退出登录请求
			this.$eventBus.$on('happy-logout-request', () => {
				console.log('[Home] 收到 happy iframe 退出登录请求，执行退出流程');
				this.onExit();
			});

			// 🔥 尝试从 localStorage 恢复登录状态（智能体分享场景）
			try {
				const savedUserInfo = localStorage.getItem('userInfo');
				if (savedUserInfo && !sessionStorage.getItem('accessToken')) {
					const userInfo = JSON.parse(savedUserInfo);
					if (userInfo?.accessToken) {
						console.log('[Home] 从 localStorage 恢复登录状态');
						// 同步到 sessionStorage
						sessionStorage.setItem('accessToken', userInfo.accessToken);
						if (userInfo.refreshToken) {
							sessionStorage.setItem('refreshToken', userInfo.refreshToken);
						}
						if (userInfo.tokenKey) {
							sessionStorage.setItem('tokenKey', userInfo.tokenKey);
						}
					}
				}
			} catch (error) {
				console.error('[Home] 从 localStorage 恢复失败:', error);
			}

			this.$store.dispatch("load").then(() => {
				// ws初始化
				this.$wsApi.connect(process.env.VUE_APP_WS_URL, sessionStorage.getItem("accessToken"));
				this.$wsApi.onConnect(() => {
					if (this.reconnecting) {
						this.onReconnectWs();
					} else {
						// 加载离线消息
						this.pullPrivateOfflineMessage(this.$store.state.chatStore.privateMsgMaxId);
						this.pullGroupOfflineMessage(this.$store.state.chatStore.groupMsgMaxId);
					}
				});
				this.$wsApi.onMessage((cmd, msgInfo) => {
					console.log('[【智能体状态debug】] 2️⃣ Home.vue onMessage 回调:', {
						cmd,
						cmdType: typeof cmd,
						cmd3Check: cmd === 3,
						type: msgInfo?.type
					});
					
					if (cmd === 2) {
						// 强制下线已禁用，忽略此命令
						console.log('[Home] 收到强制下线命令（已禁用，忽略）');
					} else if (cmd === 3) {
						// 插入私聊消息
						console.log('[【智能体状态debug】] 3️⃣ 准备调用 handlePrivateMessage');
						this.handlePrivateMessage(msgInfo);
					} else if (cmd === 4) {
						// 插入群聊消息
						this.handleGroupMessage(msgInfo);
					} else if (cmd === 5) {
						// 处理系统消息
						this.handleSystemMessage(msgInfo);
					}
				});
				this.$wsApi.onClose((e) => {
					if (e.code != 3000) {
						// 断线重连
						this.reconnectWs();
					}
				});

				this.preloadVncPod();
			}).catch((e) => {
				console.error("[Home] 初始化失败", e);
				// 🔥 初始化失败时，清除登录状态
				sessionStorage.removeItem('accessToken');
				sessionStorage.removeItem('refreshToken');
				sessionStorage.removeItem('tokenKey');
				this.$store.commit('setIsLoggedIn', false);
				// 🔥 只在当前不在登录页时才跳转，避免循环跳转
				if (this.$route.path !== '/login') {
					this.$router.replace('/login');
				}
			})
		},
		reconnectWs() {
			// 记录标志
			this.reconnecting = true;
			// 重新加载一次个人信息，目的是为了保证网络已经正常且token有效
			this.$store.dispatch("loadUser").then(() => {
				this.$wsApi.reconnect(process.env.VUE_APP_WS_URL, sessionStorage.getItem(
					"accessToken"));
			}).catch(() => {
				// 10s后重试
				setTimeout(() => this.reconnectWs(), 10000)
			})
		},
		onReconnectWs() {
			// 重连成功
			this.reconnecting = false;
			// 重新加载群和好友
			const promises = [];
			promises.push(this.$store.dispatch("loadFriend"));
			promises.push(this.$store.dispatch("loadGroup"));
			Promise.all(promises).then(() => {
				// 加载离线消息
				this.pullPrivateOfflineMessage(this.$store.state.chatStore.privateMsgMaxId);
				this.pullGroupOfflineMessage(this.$store.state.chatStore.groupMsgMaxId);
			}).catch(() => {
				this.$message.error("初始化失败");
				this.onExit();
			})
		},
		pullPrivateOfflineMessage(minId) {
			this.$store.commit("loadingPrivateMsg", true)
			this.$http({
				url: "/message/private/pullOfflineMessage?minId=" + minId,
				method: 'GET'
			}).catch(() => {
				this.$store.commit("loadingPrivateMsg", false)
			})
		},
		pullGroupOfflineMessage(minId) {
			this.$store.commit("loadingGroupMsg", true)
			this.$http({
				url: "/message/group/pullOfflineMessage?minId=" + minId,
				method: 'GET'
			}).catch(() => {
				this.$store.commit("loadingGroupMsg", false)
			})
		},
		handlePrivateMessage(msg) {
			console.log('[【智能体状态debug】] 4️⃣ handlePrivateMessage 入口, msg.type:', msg?.type);
			
			// 🔧 检查是否为终端间消息：只要有senderTerminal字段就是终端消息
			if (msg.senderTerminal !== undefined) {
				console.log("[Home] 🔧 接收到终端消息:", msg);
				// 设置终端消息标识
				msg.isTerminalChat = true;
				if (msg.targetTerminal === this.getCurrentTerminal()) {
					this.insertTerminalMessage(msg);
				}
				// 🔧 修复：终端消息也需要更新privateMsgMaxId
				if (msg.id && msg.id > this.$store.state.chatStore.privateMsgMaxId) {
					this.$store.commit('updatePrivateMsgMaxId', msg.id);
				}
				return;
			}

			// 原有的普通私聊消息处理逻辑
			// 标记这条消息是不是自己发的
			msg.selfSend = msg.sendId == this.$store.state.userStore.userInfo.id;
			// 好友id
			let friendId = msg.selfSend ? msg.recvId : msg.sendId;
			// 会话信息
			let chatInfo = {
				type: "PRIVATE",
				targetId: friendId
			}
			// 消息加载标志
			if (msg.type == this.$enums.MESSAGE_TYPE.LOADING) {
				this.$store.commit("loadingPrivateMsg", JSON.parse(msg.content))
				return;
			}
			// 消息已读处理，清空已读数量
			if (msg.type == this.$enums.MESSAGE_TYPE.READED) {
				this.$store.commit("resetUnreadCount", chatInfo)
				return;
			}
			// 消息回执处理,改消息状态为已读
			if (msg.type == this.$enums.MESSAGE_TYPE.RECEIPT) {
				this.$store.commit("readedMessage", {
					friendId: msg.sendId
				})
				return;
			}
			// 消息撤回
			if (msg.type == this.$enums.MESSAGE_TYPE.RECALL) {
				this.$store.commit("recallMessage", [msg, chatInfo])
				return;
			}
			// 新增好友
			if (msg.type == this.$enums.MESSAGE_TYPE.FRIEND_NEW) {
				this.$store.commit("addFriend", JSON.parse(msg.content));
				return;
			}
			// 删除好友
			if (msg.type == this.$enums.MESSAGE_TYPE.FRIEND_DEL) {
				this.$store.commit("removeFriend", friendId);
				return;
			}
			// 好友申请
			if (msg.type == this.$enums.MESSAGE_TYPE.FRIEND_REQUEST) {
				const data = JSON.parse(msg.content);
				this.$notify({ title: '好友申请', message: data.nickName + ' 请求添加你为好友，点击查看', type: 'info', duration: 8000, });
				this.pendingRequestCount++;
				return;
			}
			// 好友申请结果
			if (msg.type == this.$enums.MESSAGE_TYPE.FRIEND_REQUEST_RESULT) {
				const data = JSON.parse(msg.content);
				if (data.status === 'APPROVED') {
					this.$notify({ title: '好友申请', message: '对方已同意你的好友申请', type: 'success' });
				} else if (data.status === 'REJECTED') {
					this.$notify({ title: '好友申请', message: '对方已拒绝你的好友申请', type: 'warning' });
				}
				return;
			}
			// 入群申请
			if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_JOIN_REQUEST) {
				const data = JSON.parse(msg.content);
				this.$notify({ title: '入群申请', message: data.nickName + ' 申请加入群聊「' + data.groupName + '」', type: 'info', duration: 8000, });
				this.pendingRequestCount++;
				return;
			}
			// 入群申请结果
			if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_JOIN_REQUEST_RESULT) {
				const data = JSON.parse(msg.content);
				if (data.status === 'APPROVED') {
					this.$notify({ title: '入群申请', message: '群主已同意你的入群申请', type: 'success' });
				} else if (data.status === 'REJECTED') {
					this.$notify({ title: '入群申请', message: '群主已拒绝你的入群申请', type: 'warning' });
				}
				return;
			}
			// 单人webrtc 信令
			if (this.$msgType.isRtcPrivate(msg.type)) {
				this.$refs.rtcPrivateVideo.onRTCMessage(msg)
				return;
			}
			
			// 处理智能体任务状态消息 (type=60/61/62)
			if (msg.type === 60 || msg.type === 61 || msg.type === 62) {
				try {
					// 插入消息（用于持久化和历史恢复）
					let friend = this.loadFriendInfo(msg.sendId === this.$store.state.userStore.userInfo?.id ? msg.recvId : msg.sendId);
					this.insertPrivateMessage(friend, msg);

					// 更新状态索引（用于 UI 显示）
					this.$store.commit('updateAgentTaskStatusFromMessage', msg);
					return;
				} catch (e) {
					console.error('[AgentTask] 状态消息处理失败:', e);
					return;
				}
			}
			
			// 插入普通消息
			if (this.$msgType.isNormal(msg.type) || this.$msgType.isTip(msg.type) || this.$msgType.isAction(msg.type)) {
					let friend = this.loadFriendInfo(friendId);
					this.insertPrivateMessage(friend, msg);
				}
		},
		insertPrivateMessage(friend, msg) {
			let chatInfo = {
				type: 'PRIVATE',
				targetId: friend.id,
				showName: friend.nickName,
				headImage: friend.headImage,
			};
			// 打开会话
			this.$store.commit("openChat", chatInfo);
			// 插入消息
			this.$store.commit("insertMessage", [msg, chatInfo]);
			// 播放提示音
			if (!msg.selfSend && this.$msgType.isNormal(msg.type) &&
				msg.status != this.$enums.MESSAGE_STATUS.READED) {
				this.playAudioTip();
			}
		},

		// 🔧 修正：终端消息插入方法（目标终端模式）
		insertTerminalMessage(msg) {
			try {
				const userInfo = this.$store.state.userStore.userInfo;
				if (!userInfo || !userInfo.id) {
					console.error("[Home] 用户信息未加载，无法处理终端消息");
					return;
				}

				// 🔧 修正：使用发送端作为会话标识（目标终端模式）
				const senderTerminal = msg.senderTerminal;
				const targetTerminal = msg.targetTerminal || this.getCurrentTerminal(); // 如果没有targetTerminal，使用当前终端
				const currentTerminal = this.getCurrentTerminal();

				// 🔧 关键修复：确保终端消息的selfSend字段正确设置
				msg.selfSend = msg.senderTerminal === currentTerminal;

				// 🔧 补充缺失的targetTerminal字段
				if (!msg.targetTerminal) {
					msg.targetTerminal = currentTerminal;
				}

				console.log(`🔧 [Home] 终端消息: ${this.getTerminalName(senderTerminal)}端→${this.getTerminalName(targetTerminal)}端, selfSend=${msg.selfSend}`);

				// 🔧 修正：创建发送端会话信息（在目标端显示为"发送端会话"）
				const chatInfo = {
					type: "PRIVATE",
					targetId: `${userInfo.id}_${senderTerminal}`,  // 使用发送端标识
					showName: `${this.getTerminalName(senderTerminal)}端`,
					headImage: this.getTerminalIcon(senderTerminal),
					isTerminalChat: true,  // 使用新的标识
					senderTerminal: senderTerminal  // 记录发送端
				};

				// 🔧 修正：设置消息的发送者昵称（显示发送端信息）
				msg.sendNickName = `${userInfo.nickName}(${this.getTerminalName(senderTerminal)}端)`;

				// 使用统一的会话管理流程
				this.$store.commit("openChat", chatInfo);
				this.$store.commit("insertMessage", [msg, chatInfo]);

				console.log(`✅ [Home] 终端消息已插入到 ${this.getTerminalName(senderTerminal)}端 会话`);

				// 播放提示音（接收到其他终端的消息时）
				if (!msg.selfSend && this.$msgType.isNormal(msg.type) &&
					msg.status != this.$enums.MESSAGE_STATUS.READED) {
					this.playAudioTip();
				}
			} catch (error) {
				console.error("[Home] 处理终端消息失败:", error, msg);
			}
		},

		// 🔧 新增：获取终端名称的工具方法
		getTerminalName(terminal) {
			const terminalNames = {
				0: "傻蛋网页",
				1: "傻蛋精灵App",
				2: "我的电脑",
				3: "我的云电脑",
				4: "傻蛋浏览器",
				5: "MCP",
				6: "我的小龙虾"
			};
			return terminalNames[terminal] || "未知";
		},

		// 🔧 新增：获取终端图标的工具方法
		getTerminalIcon(terminal) {
			const terminalIcons = {
				0: "🌐",
				1: "📱",
				2: "💻",
				3: "🖥️",
				4: "🔌",
				5: "🤖",
				6: "🦞"
			};
			return terminalIcons[terminal] || "❓";
		},

		// 🔧 新增：获取当前终端类型
		getCurrentTerminal() {
			// 根据环境判断当前终端类型
			if (typeof window !== 'undefined') {
				// 检测VSCode环境 - 多种方式检测
				if (window.parent !== window || // 在iframe中
					window.acquireVsCodeApi || // VSCode WebView API
					window.SharedServicesAccessor || // 我们的VSCode服务
					navigator.userAgent.includes('VSCode') || // User Agent
					window.location.protocol === 'vscode-webview:') { // VSCode WebView协议
					return 2; // VSCode
				}

				// 检测Electron环境
				if (window.require ||
					window.process?.type ||
					window.isElectron ||
					navigator.userAgent.includes('Electron')) {
					return 3; // PC客户端
				}

				// 检测移动端App环境
				if (window.cordova ||
					window.PhoneGap ||
					window.phonegap ||
					navigator.userAgent.includes('wv') || // WebView
					navigator.userAgent.includes('Mobile')) {
					return 1; // App
				}

				return 0; // Web
			}
			return 0; // 默认Web
		},

		handleGroupMessage(msg) {
			// 标记这条消息是不是自己发的
			msg.selfSend = msg.sendId == this.$store.state.userStore.userInfo.id;
			let chatInfo = {
				type: 'GROUP',
				targetId: msg.groupId
			}
			// 消息加载标志
			if (msg.type == this.$enums.MESSAGE_TYPE.LOADING) {
				this.$store.commit("loadingGroupMsg", JSON.parse(msg.content))
				return;
			}
			// 消息已读处理
			if (msg.type == this.$enums.MESSAGE_TYPE.READED) {
				// 我已读对方的消息，清空已读数量
				this.$store.commit("resetUnreadCount", chatInfo)
				return;
			}
			// 消息回执处理
			if (msg.type == this.$enums.MESSAGE_TYPE.RECEIPT) {
				// 更新消息已读人数
				let msgInfo = {
					id: msg.id,
					groupId: msg.groupId,
					readedCount: msg.readedCount,
					receiptOk: msg.receiptOk
				};
				this.$store.commit("updateMessage", [msgInfo, chatInfo])
				return;
			}
			// 消息撤回
			if (msg.type == this.$enums.MESSAGE_TYPE.RECALL) {
				this.$store.commit("recallMessage", [msg, chatInfo])
				return;
			}
			// 新增群
			if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_NEW) {
				this.$store.commit("addGroup", JSON.parse(msg.content));
				return;
			}
			// 删除群
			if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_DEL) {
				this.$store.commit("removeGroup", msg.groupId);
				return;
			}
			// 群视频信令
			if (this.$msgType.isRtcGroup(msg.type)) {
				this.$nextTick(() => {
					this.$refs.rtcGroupVideo.onRTCMessage(msg);
				})
				return;
			}
			// 插入群聊消息
		// 🔥 新增：处理智能体任务状态消息 (type=60/61/62)
		if (msg.type === 60 || msg.type === 61 || msg.type === 62) {
			try {
				// 安全地解析 content
				let parsedContent;
				if (msg.content) {
					parsedContent = typeof msg.content === 'string'
						? JSON.parse(msg.content)
						: msg.content;
				}

				console.log('[【智能体状态debug】] 3️⃣ handleGroupMessage 检测到任务状态消息:', {
					type: msg.type,
					id: msg.id,
					groupId: msg.groupId,
					sendId: msg.sendId,
					taskId: parsedContent?.taskId,
					progress: parsedContent?.progress,
					message: parsedContent?.message,
					status: parsedContent?.status,
					contentKeys: parsedContent ? Object.keys(parsedContent) : null
				});

				// 直接调用 mutation 更新任务状态（不插入消息本身）
				console.log('[【智能体状态debug】] 4️⃣ 调用 updateAgentTaskStatusFromMessage');
				this.$store.commit('updateAgentTaskStatusFromMessage', msg);
				return;
			} catch (e) {
				console.error('[【智能体状态debug】] ❌ handleGroupMessage 处理失败:', e, msg);
				return;
			}
		}
					if (this.$msgType.isNormal(msg.type) || this.$msgType.isTip(msg.type) || this.$msgType.isAction(msg.type)) {
				let group = this.loadGroupInfo(msg.groupId);
				this.insertGroupMessage(group, msg);
			}
		},
		insertGroupMessage(group, msg) {
			let chatInfo = {
				type: 'GROUP',
				targetId: group.id,
				showName: group.showGroupName,
				headImage: group.headImageThumb
			};
			// 打开会话
			this.$store.commit("openChat", chatInfo);
			// 插入消息
			this.$store.commit("insertMessage", [msg, chatInfo]);
			// 播放提示音
			if (!msg.selfSend && msg.type <= this.$enums.MESSAGE_TYPE.VIDEO &&
				msg.status != this.$enums.MESSAGE_STATUS.READED) {
				this.playAudioTip();
			}
		},
		handleSystemMessage(msg) {
			// 用户被封禁
			if (msg.type == this.$enums.MESSAGE_TYPE.USER_BANNED) {
				this.$wsApi.close(3000);
				this.$alert("您的账号已被管理员封禁,原因:" + msg.content, "账号被封禁", {
					confirmButtonText: '确定',
					callback: action => {
						this.onExit();
					}
				});
				return;
			}
		},
		/**
		 * 处理智能体任务消息 (来自 im-platform 回调)
		 * @param {number} cmd - 消息类型 (60=进度, 61=结果, 62=错误)
		 * @param {Object} msgInfo - 消息内容
		 */
	handleAgentTaskMessage(cmd, msgInfo) {
		console.log('[Home] 收到智能体任务消息:', { cmd, msgInfo });

		// 解析消息内容
		let parsedContent;
		try {
			parsedContent = typeof msgInfo.content === 'string'
				? JSON.parse(msgInfo.content)
				: msgInfo.content;
		} catch (e) {
			console.error('[Home] 解析智能体任务消息失败:', e);
			return;
		}

		const { taskId, sessionId, progress, message, result } = parsedContent;

		// 如果没有taskId但有sessionId，通过映射查找taskId
		let actualTaskId = taskId;
		if (!actualTaskId && sessionId) {
			actualTaskId = this.$store.state.chatStore.agentTaskSessionMappings[sessionId];
		}

		if (!actualTaskId) {
			console.warn('[Home] 找不到taskId，无法更新任务状态', { taskId, sessionId });
			return;
		}

		// 根据cmd类型确定newStatus和extraData
		let newStatus, statusMessage, extraData = {};

		if (cmd === 60 || parsedContent.type === 60) {
			// 进度更新
			newStatus = 'running';
			statusMessage = message || `任务执行中... (${progress || 0}%)`;
			console.log(`[Home] 任务 ${actualTaskId} 进度: ${progress}%`);
		} else if (cmd === 61 || parsedContent.type === 61) {
			// 任务完成
			newStatus = 'completed';
			statusMessage = message || '任务已完成';
			extraData.result = {
				status: 'success',
				message: statusMessage,
				data: result
			};
			console.log(`[Home] 任务 ${actualTaskId} 完成`);
			this.$message.success(statusMessage);
		} else if (cmd === 62 || parsedContent.type === 62) {
			// 任务失败
			newStatus = 'error';
			statusMessage = message || '任务执行失败';
			extraData.result = {
				status: 'error',
				message: statusMessage,
				data: result
			};
			console.error(`[Home] 任务 ${actualTaskId} 失败:`, message);
			this.$message.error(statusMessage);
		}

		// 如果有sessionId但还没有建立映射，建立映射
		if (sessionId && !extraData.sessionId) {
			extraData.sessionId = sessionId;
		}

		// 更新任务状态
		this.$store.commit('chatStore/updateAgentTaskStatus', {
			taskId: actualTaskId,
			newStatus,
			message: statusMessage,
			extraData
		});

		// 发布事件供其他组件监听
		this.$bus.$emit('agent-task-update', { cmd, taskId: actualTaskId, progress, message: statusMessage, sessionId, result });
	},
		async onExit() {
			// 设置登出状态
			this.isLoggingOut = true;

			// 通知 happy iframe 清除认证凭证，等待确认
			await this.notifyHappyLogout();

			this.$wsApi.close(3000);
			sessionStorage.removeItem("accessToken");
			// 🔥 同时清理 localStorage 和其他 sessionStorage
			sessionStorage.removeItem('refreshToken');
			sessionStorage.removeItem('tokenKey');
			localStorage.removeItem('userInfo');
			location.href = "/";
		},
		
		// 通知 happy iframe 退出登录，等待 ACK 确认
		notifyHappyLogout() {
			return new Promise((resolve) => {
				// 尝试通过 bridge 发送（优先）
				const bridge = window.__imHappyIframeBridge;
				if (bridge && bridge.getIsReady && bridge.getIsReady()) {
					let ackReceived = false;
					let timeoutId = null;

					// 监听 ACK 确认
					const ackHandler = (data) => {
						if (data && data.messageType === 'USER_LOGOUT') {
							ackReceived = true;
							if (timeoutId) clearTimeout(timeoutId);
							bridge.off('ack', ackHandler);
							resolve();
						}
					};

					bridge.on('ack', ackHandler);

					// 发送退出登录消息
					try {
						bridge.sendUserLogout();

						// 设置超时（2秒），避免无限等待
						timeoutId = setTimeout(() => {
							if (!ackReceived) {
								bridge.off('ack', ackHandler);
								resolve();
							}
						}, 2000);
					} catch (error) {
						console.error('[Home] ❌ bridge 发送失败:', error);
						bridge.off('ack', ackHandler);
						resolve();
					}
				} else {
					// 降级方案：直接通过 postMessage 发送
					const iframe = document.querySelector('.agent-iframe');
					if (!iframe || !iframe.contentWindow) {
						resolve();
						return;
					}

					const targetOrigin = process.env.NODE_ENV === 'production'
						? 'https://happy.shadanai.com'
						: 'http://localhost:8081';

					try {
						const message = {
							type: 'USER_LOGOUT',
							data: { timestamp: Date.now() },
							timestamp: Date.now(),
							messageId: `logout_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
						};

						iframe.contentWindow.postMessage(message, targetOrigin);

						// 不等待确认，直接继续
						setTimeout(resolve, 500);
					} catch (error) {
						console.error('[Home] ❌ postMessage 发送失败:', error);
						resolve();
					}
				}
			});
		},
		playAudioTip() {
			// 离线消息不播放铃声
			if (this.$store.getters.isLoading()) {
				return;
			}
			// 防止过于密集播放
			if (new Date().getTime() - this.lastPlayAudioTime > 1000) {
				this.lastPlayAudioTime = new Date().getTime();
				let audio = new Audio();
				let url = require(`@/assets/audio/tip.wav`);
				audio.src = url;
				audio.play();
			}

		},
		showSetting() {
			this.showSettingDialog = true;
		},
		closeSetting() {
			this.showSettingDialog = false;
		},
		handleAvatarClick() {
			if (this.isLoggedIn) {
				this.showSettingDialog = true;
			} else {
				window.open('https://www.shadanai.com', '_blank');
			}
		},
		handleLogoClick() {
			const isLoggedIn = this.$store.getters.isLoggedIn
			const hasToken = sessionStorage.getItem('accessToken')
			
			if (!isLoggedIn && !hasToken) {
				window.open('https://www.shadanai.com', '_blank');
			}
		},
		handleMenuClick(path) {
			if (!this.isLoggedIn) {
				this.goToLogin();
				return;
			}
			if (path === '/home/chat') {
				this.onChatMenuClick();
			} else {
				this.$router.push(path);
			}
		},
		goToLogin() {
			this.$router.push('/login');
		},
		loadFriendInfo(id) {
			if (String(id).includes('_')) {
				id = String(id).split('_')[0];
			}
			let friend = this.$store.getters.findFriend(id);
			if (!friend) {
				// 🔧 修复：如果是当前用户自己，返回用户自己的信息
				const currentUser = this.$store.state.userStore.userInfo;
				if (currentUser && currentUser.id == id) {
					friend = {
						id: id,
						nickName: currentUser.nickName || "我",
						showNickName: currentUser.nickName || "我",
						headImage: currentUser.headImageThumb || currentUser.headImage || "",
					};
				} else {
					// 其他未知用户
					friend = {
						id: id,
						nickName: "未知用户",
						showNickName: "未知用户",
						headImage: ""
					}
				}
			}
			return friend;
		},
		loadGroupInfo(id) {
			let group = this.$store.getters.findGroup(id);
			if (!group) {
				group = {
					id: id,
					showGroupName: "未知群聊",
					headImageThumb: ""
				}
			}
			return group;
		}
	},
	computed: {
		uiStore() {
			return this.$store.state.uiStore;
		},
		// 是否为移动端全屏模式
		isMobileFullscreen() {
			return this.$route.query.fullscreen === 'true';
		},
		// 是否已登录
		isLoggedIn() {
			return this.$store.getters.isLoggedIn && !!sessionStorage.getItem('accessToken');
		},
		unreadCount() {
			let unreadCount = 0;
			let chats = this.$store.state.chatStore.chats;
			chats.forEach((chat) => {
				if (!chat.delete) {
					unreadCount += chat.unreadCount
				}
			});
			return unreadCount;
		}
	},
	watch: {
		unreadCount: {
			handler(newCount, oldCount) {
				let tip = newCount > 0 ? `${newCount}条未读` : "";
				this.$elm.setTitleTip(tip);
				// 🔥 新增：更新浏览器标题未读提示
				titleNotifier.updateCount(newCount);
			},
			immediate: true
		}
	},
	mounted() {
		// 检查是否已登录
		const hasToken = sessionStorage.getItem('accessToken')
		const isLoggedIn = this.$store.getters.isLoggedIn
		
		// 只有在已登录时才初始化
		if (!hasToken || !isLoggedIn) {
			console.log('[Home] 未登录访问，跳过初始化')
			return
		}
		
		this.init();
	},
	unmounted() {
		this.$wsApi.close();
	}
}
</script>

<style scoped lang="scss">
.home-page {
	height: 100vh;
	width: 100vw;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 4px;
	overflow: hidden;
	background: var(--im-color-primary-light-9);

	// 🔥 移动端全屏模式：重置所有限制
	&.mobile-fullscreen-mode {
		overflow: visible !important;
		border-radius: 0 !important;
	}

	.app-container {
		width: 62vw;
		height: 80vh;
		display: flex;
		min-height: 600px;
		min-width: 970px;
		position: absolute;
		border-radius: 4px;
		overflow: hidden;
		box-shadow: var(--im-box-shadow-dark);
		transition: 0.2s;

		&.fullscreen {
			transition: 0.2s;
			width: 100vw;
			height: 100vh;
		}

		// 🔥 移动端全屏模式：彻底重置容器限制
		&.mobile-fullscreen-mode {
			position: fixed !important;
			top: 0 !important;
			left: 0 !important;
			width: 100vw !important;
			height: 100vh !important;
			min-width: 0 !important;
			min-height: 0 !important;
			border-radius: 0 !important;
			overflow: visible !important;
			box-shadow: none !important;
		}
	}

	.navi-bar {
		--icon-font-size: 22px;
		--width: 60px;
		width: var(--width);
		background: rgba(255, 255, 255, 0.4);
		padding-top: 20px;

		.navi-bar-box {
			height: 100%;
			display: flex;
			flex-direction: column;
			justify-content: space-between;

			.botoom {
				margin-bottom: 30px;
			}
		}

		.user-head-image {
			display: flex;
			justify-content: center;
		}

		.menu {
			height: 300px;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-content: center;

			.link {
				text-decoration: none;
				cursor: pointer;
			}

			.router-link-active .menu-item {
				color: rgba(97, 94, 240, 1);
				background: transparent;
			}

			.link:not(.router-link-active) .menu-item:hover {
				background: rgba(0, 0, 0, 0.05);
				border-radius: 8px;
			}

			.menu-item {
				position: relative;
				color: rgba(131, 131, 131, 1);
				width: var(--width);
				height: 46px;
				display: flex;
				justify-content: center;
				align-items: center;
				margin-bottom: 12px;

				.icon {
					font-size: var(--icon-font-size)
				}

				.icon-home-svg {
					width: 20px;
					height: 20px;
				}

				.unread-text {
					position: absolute;
					background-color: var(--im-color-danger);
					left: 28px;
					top: 8px;
					color: white;
					border-radius: 30px;
					padding: 0 5px;
					font-size: var(--im-font-size-smaller);
					text-align: center;
					white-space: nowrap;
					border: 1px solid #f1e5e5;
				}
			}
		}

		.botoom-item {
			display: flex;
			justify-content: center;
			align-items: center;
			height: 50px;
			width: 100%;
			cursor: pointer;
			color: rgba(131, 131, 131, 1);
			font-size: var(--icon-font-size);

			.icon {
				font-size: var(--icon-font-size)
			}

			&:hover {
				background: rgba(0, 0, 0, 0.05);
				border-radius: 8px;
			}
		}
	}

	// 页面切换过渡动画
	.page-fade-enter-active,
	.page-fade-leave-active {
		transition: opacity 0.2s ease, transform 0.2s ease;
	}
	
	.page-fade-enter {
		opacity: 0;
		transform: translateX(20px);
	}
	
	.page-fade-leave-to {
		opacity: 0;
		transform: translateX(-20px);
	}

	.content-box {
		flex: 1;
		padding: 0;
		background-color: #fff;
		text-align: center;
		overflow: auto;
	}

	.content-box:has(.ai-assistant-page) {
		background-color: transparent;
	}

	// 🔥 移动端全屏模式：content-box也不限制
	.mobile-fullscreen-mode .content-box {
		position: fixed !important;
		top: 0 !important;
		left: 0 !important;
		width: 100vw !important;
		height: 100vh !important;
		overflow: visible !important;
	}
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
	.home-page {
		border-radius: 0;

		.app-container {
			width: 100vw !important;
			height: 100vh !important;
			min-width: 0 !important;
			min-height: 0 !important;
			border-radius: 0 !important;
			box-shadow: none !important;
			flex-direction: column;

			&.fullscreen {
				width: 100vw;
				height: 100vh;
			}
		}

		.navi-bar {
			order: 2;
			width: 100% !important;
			padding-top: 0;
			position: fixed;
			bottom: 0;
			left: 0;
			right: 0;
			z-index: 200;
			background: #fff;
			border-top: 1px solid #e8e8e8;

			.navi-bar-box {
				flex-direction: row !important;
				justify-content: center !important;
				height: auto !important;

				.top {
					width: 100%;
					display: flex;
					align-items: center;

					.user-head-image {
						display: none;
					}

					.menu {
						flex-direction: row !important;
						height: auto !important;
						width: 100%;
						justify-content: space-around !important;

						.link {
							flex: 1;
						}

						.menu-item {
							width: auto !important;
							height: 50px;
							margin-bottom: 0 !important;
							padding-bottom: env(safe-area-inset-bottom, 0px);
						}
					}
				}

				.botoom {
					display: none !important;
				}
			}
		}

		.content-box {
			order: 1;
			flex: 1;
			height: 0;
			padding-bottom: 50px;
			overflow: auto;
			-webkit-overflow-scrolling: touch;
		}
	}
}
</style>
